var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 447.243 447.243",
    viewBox: "0 0 447.243 447.243",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m420.361 192.229c-1.83-.297-3.682-.434-5.535-.41h-315.521l6.88-3.2c6.725-3.183 12.843-7.515 18.08-12.8l88.48-88.48c11.653-11.124 13.611-29.019 4.64-42.4-10.441-14.259-30.464-17.355-44.724-6.914-1.152.844-2.247 1.764-3.276 2.754l-160 160c-12.504 12.49-12.515 32.751-.025 45.255.008.008.017.017.025.025l160 160c12.514 12.479 32.775 12.451 45.255-.063.982-.985 1.899-2.033 2.745-3.137 8.971-13.381 7.013-31.276-4.64-42.4l-88.32-88.64c-4.695-4.7-10.093-8.641-16-11.68l-9.6-4.32h314.24c16.347.607 30.689-10.812 33.76-26.88 2.829-17.445-9.019-33.88-26.464-36.71z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow-back.7c6a46b732dbe17e8e7d39a8f2a2cb3a.svg";
export { ForwardRef as ReactComponent };